export const listPath = [
    {
        name: 'Главная',
        path: '/',
    },
    {
        name: 'Кейсы',
        path: '/cases',
    },
    {
        name: 'Разработка',
        path: '/cases/development',
    },
];
export const listTitle = [
    {
        title: '14&nbsp;интеграций, новый личный кабинет и&nbsp;одна цель',
        subtitle: 'Разработка Личного кабинета продавца продуктов КАСКО и&nbsp;ОСАГО',
        description: [
            {
                name: 'Отрасль',
                details: 'Страхование',
            },
            {
                name: 'Услуги',
                details: 'Разработка ЛК',
            },
            {
                name: 'Сроки',
                details: 'январь 2024 – декабрь 2024',
            },
        ],
        company: 'ПАО СК «Росгосстрах»',
        companyLink: 'https://www.rgs.ru/',
        companyLinkName: 'www.rgs.ru',
        text:
            'Российская страховая компания, является одной' +
            ' из&nbsp;крупнейших по&nbsp;масштабам, собранным' +
            ' страховым премиям, активам и&nbsp;резервам' +
            ' страховой организацией в&nbsp;России',
    },
];

export const listStages = [
    {
        number: '1.',
        text:
            'Создание единого кросс-функционального окна для управления договорами' +
            ' на&nbsp;разных стадиях (от&nbsp;предпродажи до&nbsp;пролонгации и&nbsp;расторжения).',
    },
    {
        number: '2.',
        text:
            'Ускорение процесса оформления страховых' +
            ' договоров за&nbsp;счет оптимизации всех этапов продаж.',
    },
    {
        number: '3.',
        text: 'Повышение качества и&nbsp;точности услуг, минимизация ошибок при работе с&nbsp;договорами.',
    },
    {
        number: '4.',
        text:
            'Улучшение удобства использования системы для сотрудников,' +
            ' в&nbsp;том числе страховых агентов, с&nbsp;любого' +
            ' устройства: от&nbsp;мобильного до&nbsp;ПК.',
    },
    {
        number: '5.',
        text: 'Обеспечение доступности системы для всех категорий пользователей.',
    },
    {
        number: '6.',
        text:
            'Повышение конкурентоспособности компании на&nbsp;страховом' +
            ' рынке за&nbsp;счет более гибкой и&nbsp;эффективной' +
            ' системы работы с&nbsp;клиентами.',
    },
];

export const listRealization = [
    {
        description:
            'Backend-разработчики реализовали 14&nbsp;интеграций с&nbsp;использованием BFF-слоя.',
    },
    {
        description:
            'Frontend-разработчики использовали компонентно-ориентированный подход к&nbsp;построению' +
            ' интерфейса на&nbsp;основе микрофронтендов, чтобы собрать всю систему' +
            ' и&nbsp;сделать ее&nbsp;гибкой и&nbsp;масштабируемой.',
    },
    {
        description:
            'Плотное взаимодействие с&nbsp;другими подрядчиками' +
            ' заказчика вместе с&nbsp;параллельным этапом разработки.',
    },
    {
        description:
            'QA&nbsp;создали полноценную многоуровневую тестовую модель с&nbsp;высоким' +
            ' процентом покрытия тестами требований, и&nbsp;обеспечивающую контроль' +
            ' качества на&nbsp;всех этапах разработки. В&nbsp;том числе выполнили' +
            ' тестирование производительности.',
    },
];
export const listMicrofrontend = [
    {
        title: 'BFF паттерн',
    },
    {
        title: 'TypeScript 5+',
    },
    {
        title: 'React 18',
    },
    {
        title: 'Webpack',
    },
    {
        title: 'Module Federation',
    },
    {
        title: 'Yarn',
    },
    {
        title: 'React Hook Form',
    },
    {
        title: 'Zod',
    },
    {
        title: 'Docker',
    },
    {
        title: 'Redux, Redux Toolkit, RTK Query + Codegen Api',
    },
];

export const listRalization = [
    {
        title: 'Jmeter',
    },
    {
        title: 'Mockserver',
    },
    {
        title: 'AppDynamics',
    },
    {
        title: 'Selenium',
    },
    {
        title: 'Java',
    },
    {
        title: 'Atlas WebDriver wrapper',
    },
    {
        title: 'POM паттерн',
    },
    {
        title: 'Steps паттерн',
    },
    {
        title: 'Allure TestOps',
    },
    {
        title: 'Zephyr Scale',
    },
    {
        title: 'Jest',
    },
];

export const listChallenges = [
    {
        title: 'Ускорение бизнес-процессов оформления и&nbsp;обработки договоров страхования',
        icon: '/images/pic/rgs/svg/c1.svg',
        width: 206,
        height: 206,
    },
    {
        title: 'Гибкость и&nbsp;масштабируемость за&nbsp;счет микросервисной архитектуры',
        icon: '/images/pic/rgs/svg/c2.svg',
        width: 206,
        height: 206,
    },
    {
        title: 'Объединили&nbsp;в&nbsp;единую информационную систему&nbsp;14 микрофронтов',
        icon: '/images/pic/rgs/svg/c3.svg',
        width: 206,
        height: 206,
    },
    {
        title: 'Улучшение клиентского опыта и&nbsp;повышение конкурентоспособности компании',
        icon: '/images/pic/rgs/svg/c4.svg',
        width: 239,
        height: 239,
    },
];
export const listReviewTitle = 'Клиент о нас';
export const listReviewAuthor = 'Команда ПАО СК&nbsp;&laquo;Росгосстрах&raquo;';
export const listReviewIcon = '/images/pic/rgs/svg/logo1.svg';
export const listReview = [
    {
        paragraph:
            'Проект создания единого личного кабинета для продавцов стал' +
            ' сложным и&nbsp;успешным этапом нашего сотрудничества.' +
            ' Одним из&nbsp;ключевых технических вызовов проекта' +
            ' стал существенный объём интеграций. Потребовалась' +
            ' тщательная аналитика и&nbsp;ювелирная точность' +
            ' при проектировании архитектуры.',
    },
    {
        paragraph:
            'Команда &laquo;Вебпрактик&raquo; успешно справилась' +
            ' со&nbsp;всеми сложностями и&nbsp;реализовала' +
            ' фронтенд-решение, которое &laquo;сшило&raquo; данные' +
            ' из&nbsp;всех подсистем, создав удобный единый' +
            ' интерфейс для пользователей.',
    },
    {
        paragraph:
            'Подход к&nbsp;проектированию микросервисной архитектуры' +
            ' оказался отличным решением для нашего проекта,' +
            ' что существенно ускорило процесс разработки' +
            ' и&nbsp;дало возможность гибко внедрять новые' +
            ' функции в&nbsp;дальнейшем.',
    },
];
